import bootstrap from 'bootstrap';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap'
import { UserContext } from './App';

const NavigationBar = (userContext : UserContext, setUserContext : (x:boolean) => void) => {
    const testUserContext = {
        id: 1,
        avatarID: '61ff3d6ef7e387abdedc64e3',
        googleKey: 'hey',
        name: 'Carlos Smith',
        occupation: 'Roboticist',
      }
      
    const testUser2Context = {
    id: 2,
    avatarID: '61ff3d6ef7e387abdedc64e3',
    googleKey: 'hey',
    name: 'Samantha Green',
    occupation: 'Occupational Therapist',
    }
    return (
        <Navbar expand="lg" className='bg-eblue'>
            <Container>
                <Navbar.Brand href="/">SPARCS-<i>box</i></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">
                    <Nav.Link href="/">Home</Nav.Link>
                    <Nav.Link href="/avatars">Web tool</Nav.Link>
                </Nav>
                <Nav className="ms-auto">
                    <NavDropdown title={userContext.name + ' (' + userContext.occupation + ')'} id="basic-nav-dropdown" className='bg-eblue'>
                        {/* <NavDropdown.Item href="/my_workflows">My workflows</NavDropdown.Item>
                        <NavDropdown.Divider /> */}
                        <NavDropdown.Item href="#action/3.4" onClick={() => {console.log('hey'); window.sessionStorage.setItem('user', JSON.stringify(testUserContext)); window.location.reload();}}>Carlos Smith</NavDropdown.Item>
                        <NavDropdown.Item href="#action/3.4" onClick={() => {window.sessionStorage.setItem('user', JSON.stringify(testUser2Context)); console.log('sesh2', window.sessionStorage.getItem('user')); window.location.reload();}}>Samantha Green</NavDropdown.Item>
                    </NavDropdown>
                </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavigationBar;
